import { render } from "./PaymentsCollections.vue?vue&type=template&id=29d088aa&scoped=true"
import script from "./PaymentsCollections.vue?vue&type=script&lang=js"
export * from "./PaymentsCollections.vue?vue&type=script&lang=js"

import "./PaymentsCollections.vue?vue&type=style&index=0&id=29d088aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29d088aa"]])

export default __exports__